export default "__VITE_ASSET__DvoBgPZw__"